/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import showFields from './mixins/showFields';
import queryField from './mixins/queryField';
import quickFilter from './mixins/quickFilter';
import page from './mixins/page';
import oper from './mixins/oper';
export default {
  mixins: [showFields, queryField, quickFilter, page, oper],
  created: function created() {
    if (this.funcMark !== '') {
      this.dataGridId = this.funcMark;
    } else if (this.gridMark !== '') {
      this.dataGridId = this.gridMark;
    }
    var clear = this.$route.query.clear;
    this.clearCache = clear;
    this.browsePerm = this.browse;
  },

  props: {
    funcMark: {
      type: String,
      default: ''
    },
    gridMark: {
      type: String,
      default: ''
    },
    beforeRender: {
      type: Function,
      default: null
    },
    browse: {
      type: Boolean,
      default: true
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    extendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chineseSort: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    displayQuery: {
      type: Boolean,
      default: true
    },
    customFunc: false
  },
  mounted: function mounted() {
    this.initId();
    this.init_grid();
    // if (this.mark !== '') {
    // this.init_grid_config(this.dataGridId)
    // } else if (this.config !== null) {
    // this.init(this.config)
    // }
  },

  watch: {
    dataGridWidth: function dataGridWidth(width) {
      // 监听列表宽度变化
      this.cal_show_field_wdith(this.dataGridColumns);
    }
  },
  methods: {
    initId: function initId() {
      if (this.$route.query.mark) {
        this.dataGridId = this.$route.query.mark;
      } else if (serverConfig['APP_PREFIX'] && serverConfig['APP_PREFIX'] == true && serverConfig['APP_CODE']) {
        if (!this.dataGridId.startsWith(serverConfig['APP_CODE']) && !this.dataGridId.startsWith('bsp:')) {
          this.dataGridId = serverConfig['APP_CODE'] + ":" + this.dataGridId;
        }
      }
    },
    init_grid: function init_grid() {
      if (this.funcMark !== '') {
        this.init_func_config(this.dataGridId);
      } else if (this.gridMark !== '') {
        this.showOper = false;
        this.init_grid_config(this.dataGridId);
      }
    },
    compareDateTime: function compareDateTime(condi, type) {
      if (type === 2) {
        //
        if (condi.start && condi.end) {
          if (condi.end < condi.start) {
            this.$Message['error']({
              background: true,
              content: '查询结束时间应大于开始时间'
            });
            condi.end = '';
          }
        }
      } else if (type === 1) {
        if (condi.end < condi.start) {
          if (condi.start && condi.end) {
            if (condi.end < condi.start) {
              this.$Message['error']({
                background: true,
                content: '查询开始时间应小于结束时间'
              });
              condi.start = '';
            }
          }
        }
      }
    },
    init: function init(resp) {
      var _this = this;

      this.returnParams = resp;
      this.comModel = resp.comModel;
      this.comModelProps = JSON.parse(resp.comModel.attachProps);
      this.dataGridHeight = this.comModelProps.height;
      if (this.comModelProps.labelWidth) {
        this.labelWidth = Number(this.comModelProps.labelWidth);
      }
      this.modelShowFields = resp.showFields;
      // 查询条件
      if (this.comModel.isSearch && this.comModel.isSearch === '1' && resp.queryFields) {
        if (this.comModelProps.searchType) {
          this.searchType = this.comModelProps.searchType;
        }
        this.build_query_fields(resp.queryFields);
      }
      // 快速筛选
      if (this.comModelProps.isQuickFilter && this.comModelProps.isQuickFilter === '1') {
        // 添加可配置默认标签配置判断
        if (this.params && this.params.isDefaultTitle && resp.quickFilter && resp.quickFilter.length > 0) {
          resp.quickFilter.forEach(function (item) {
            if (item.label == _this.params.isDefaultTitle) {
              _this.$set(item, 'isDefault', '1');
            } else {
              _this.$set(item, 'isDefault', '0');
            }
          });
        }
        this.build_quick_filter(resp.quickFilter);
      }
      // 分页
      if (!this.comModelProps.usePager) {
        this.pageSearch = false;
      }
      this.bulid_page(this.comModelProps.pageSizeOptions, this.comModelProps.pageSize);
      this.column = [];
      this.build_show_field();
      this.query_grid_data();
      var elementResizeDetectorMaker = require('element-resize-detector');
      // 监听元素变化
      var erd = elementResizeDetectorMaker();
      var that = this;
      console.log(this.dataGridId, 'this.dataGridIddocument.getElementById(this.dataGridId)');
      if (this.dataGridId && document.getElementById(this.dataGridId)) {
        console.log(document.getElementById(this.dataGridId), 'document.getElementById(this.dataGridId)');
        erd.listenTo(document.getElementById(this.dataGridId), function (element) {
          that.$nextTick(function () {
            that.dataGridWidth = element.offsetWidth;
          });
        });
      }
    },
    init_grid_config: function init_grid_config(mark) {
      var _this2 = this;

      var params = { mark: mark };
      if (this.clearCache === '1') {
        params.clearCache = 'true';
      }
      this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/viewGrid', params: params }).then(function (resp) {
        _this2.dataGridLoad = true;
        if (resp.success) {
          _this2.dbType = resp.dbType;
          _this2.init(resp);
        }
      });
    },
    init_func_config: function init_func_config(mark) {
      var _this3 = this;

      var params = { mark: mark };
      if (this.clearCache === '1') {
        params.clearCache = 'true';
      }
      this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/funcGrid', params: params }).then(function (resp) {
        if (resp.success) {
          _this3.errorMsg = '';
          _this3.dataGridLoad = true;
          _this3.exportMaxCount = resp.exportMaxCount;
          var headOper = [];
          var headOperBatch = [];
          var rowOper = [];
          var rowOperBatch = [];
          var funcMark = [];
          if (resp.oper && resp.oper.length > 0) {
            resp.oper.forEach(function (item) {
              // debugger
              if (item.attachProps && item.attachProps !== '') {
                var props = JSON.parse(item.attachProps);
                Object.assign(item, props);
              }
              if (item.auth && item.auth !== '') {
                funcMark.push(item.mark);
              }
              if (item.dispPos === '1') {
                // 头操作
                if (item.batch) {
                  headOperBatch.push(item);
                } else {
                  headOper.push(item);
                }
              } else if (item.dispPos === '2') {
                // 行操作
                _this3.hasRowOper = true;
                if (item.batch) {
                  rowOperBatch.push(item);
                } else {
                  rowOper.push(item);
                }
              }
            });
          }

          _this3.funcAuth = funcMark;
          _this3.headOper = headOper;
          _this3.headOperBatch = headOperBatch;
          _this3.rowOper = rowOper;
          _this3.rowOperBatch = rowOperBatch;
          _this3.dbType = resp.dbType;
          console.log(resp, 'resp');
          _this3.init(resp);
        } else {
          _this3.loading = false;
          _this3.dataGridLoad = false;
          _this3.errorMsg = resp.msg;
        }
      });
    },
    getCustomFields: function getCustomFields(mark) {
      var _this4 = this;

      if (this.loading || this.showModal) {
        return;
      }
      this.loading = true;
      var params = { mark: mark };
      this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/getCustomShowFields', params: params }).then(function (resp) {
        _this4.loading = false;
        if (resp.success) {
          var datas = resp.data;
          var fieldList = [];
          datas.forEach(function (item, index) {
            var check = false;
            if (item.isDisplay === '1') {
              check = true;
            }
            fieldList.push({ label: item.description, check: check, name: item.name, require: item.require });
          });
          _this4.customShowList = fieldList;
          _this4.showModal = true;
        } else {
          _this4.$Modal.warning({
            title: '温馨提示',
            content: resp.msg
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.showModal = false;
    },
    handleSet: function handleSet() {
      var _this5 = this;

      this.$Modal.confirm({
        title: '温馨提示',
        content: '是否恢复系统默认设置？',
        loading: true,
        okText: '确定',
        onOk: function onOk() {
          _this5.saveCustomReset();
        }
      });
      //resetShowFields
    },
    handleSubmit: function handleSubmit() {
      var _this6 = this;

      var arr = [];
      this.customShowList.forEach(function (item, index) {
        if (item.check) {
          arr.push(item.name + ":1");
        } else {
          arr.push(item.name + ":0");
        }
      });
      var params = { mark: this.dataGridId, fields: arr.join(",").toUpperCase() };
      this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/saveCustomShowFields', params: params }).then(function (resp) {
        if (resp.success) {
          _this6.showModal = false;
          _this6.init_grid();
        } else {}
      });
    },
    saveCustomReset: function saveCustomReset() {
      var _this7 = this;

      var params = { mark: this.dataGridId };
      this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/resetShowFields', params: params }).then(function (resp) {
        _this7.showModal = false;
        _this7.init_grid();
        _this7.$Modal.remove();
      });
    },
    multi_col_sort: function multi_col_sort() {
      this.getCustomFields(this.dataGridId);
      //this.showModal = true
      // console.log(this.column, '7777')
    },
    openSetPage: function openSetPage(token) {
      var modelSettingPath = '/#/setting/grid';
      if ('menu' === serverConfig.MODEL_SETTING_TYPE) {
        modelSettingPath = '/#/app/public/model';
      }
      var path = (serverConfig['BSP_URL'] ? serverConfig.BSP_URL : '') + modelSettingPath + '?appId=' + this.comModel.appId + '&id=' + this.comModel.id + "&singleSignOnToken=" + token;
      window.open(path);
    },
    dragstart: function dragstart(index) {
      this.dragIndex = index;
    },
    dragenter: function dragenter(e, index) {
      e.preventDefault();
      // 避免源对象触发自身的dragenter事件
      if (this.dragIndex !== index) {
        var source = this.customShowList[this.dragIndex];
        this.customShowList.splice(this.dragIndex, 1);
        this.customShowList.splice(index, 0, source);
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index;
      }
    },
    dragover: function dragover(e, index) {
      e.preventDefault();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/dataGrid.js
// module id = 23
// module chunks = 0